import {
    DIC
} from '@/const/dic'
import {
    validateChinese
} from '@/util/validate'
import {
    formatterTime
} from '@/util/util'



export const distributionSheetOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    //viewBtn: true,
    menuWidth: '150',
    labelWidth: '150',
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [{
            label: "配送单编号",
            prop: "distributionNum",
            type: "input",
            width: "200",
            addVisdiplay: false,
            editVisdiplay: false
        }, {
            label: "下单人",
            prop: "bookingClerk",
            type: "input",
            width: "200",
            search: true,
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "下单人电话",
            prop: "bookingTel",
            search: true,
            width: "110",
            type: 'input'
        },
        {
            label: "联系人",
            prop: "contactsName",
            search: true,
            type: 'input'
        },
        {
            label: "联系人电话",
            prop: "contactsMobile",
            search: true,
            width: "110",
            type: 'input'
        },

        {

            label: "配送地址",
            prop: "address",
            hide: true,
            solt: true,
            formsolt: true
        },
        {
            label: "供货商",
            prop: "supplierId",
            hide: true,
            solt: true,
            formsolt: true
        }, {
            label: "配送经销商",
            prop: "distributorName",
            search: true,
            type: 'input'
        },
        {
            label: "配送经销商电话",
            prop: "distributorMobile",
            width: "110",
            search: true,
            type: 'input'
        },
        {
            label: "创建时间",
            prop: "createTime",
            type: "datetime",
            sortable: true,
            width: "100",
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: false,
            editVisdiplay: false
        },

        {
            label: "配送费",
            prop: "distributionCost",
            width: "110",
            type: 'input'
        },
        {
            label: "配送单状态",
            prop: "status",
            type: "select",
            // solt: true,
            dicData: DIC.DISTRIBUTION_SHEET_STATUS,
            search: true,
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "出货类型",
            prop: "type",
            type: "select",
            // solt: true,
            dicData: DIC.SHOP_TYPE,
            search: true,
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "收货时间",
            prop: "receiveTime",
            type: "datetime",
            sortable: true,
            width: "100",
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "创建时间",
            prop: "startDate_endDate",
            type: "datetimerange",
            valueFormat: "timestamp",
            span: 24,
            clearable: true,
            hide: true,
            search: true,
            addVisdiplay: false,
            editVisdiplay: false,
            formatter: function (row, value, label, column) {
                return formatterTime(row.startTime) + '至' + formatterTime(row.endTime)
            }
        },
        {
            label: "收货时间",
            prop: "receiveTimeStart_receiveTimeEnd",
            type: "datetimerange",
            valueFormat: "timestamp",
            span: 24,
            clearable: true,
            hide: true,
            search: true,
            addVisdiplay: false,
            editVisdiplay: false,
            formatter: function (row, value, label, column) {
                return formatterTime(row.startTime) + '至' + formatterTime(row.endTime)
            }
        },
        // {
        //     label: "创建人",
        //     prop: "createBy",
        //     type: "input",
        //     addVisdiplay: false,
        //     editVisdiplay: false
        // },
        // {
        //     label: "状态",
        //     prop: "status",
        //     type: "radio",
        //     addVisdiplay: false,
        //     editVisdiplay: false,
        //     dicData: DIC.STATE
        // },
        // {
        //     label: "更新时间",
        //     prop: "updateTime",
        //     type: "datetime",
        //     format: "yyyy-MM-dd HH:mm:ss",
        //     hide: true,
        //     addVisdiplay: false,
        //     editVisdiplay: false
        // },
        // {
        //     label: "更新人",
        //     prop: "updateBy",
        //     type: "input",
        //     hide: true,
        //     addVisdiplay: false,
        //     editVisdiplay: false
        // },
        // {
        //     label: "是否删除",
        //     prop: "deleteFlag",
        //     type: "radio",
        //     hide: true,
        //     addVisdiplay: false,
        //     editVisdiplay: false,
        //     dicData: DIC.DELETE_FLAG
        // },
        {
            label: "备注",
            prop: "remarks",
            type: "textarea",
            hide: true,
            span: 24,
            max: 255
        }
    ]
};